import {Record, List} from 'immutable';

import Name, {type Name as NameRecord} from 'web-app/react/entities/common/name';
import {type EntityModel} from 'web-app/react/entities/factory';

interface IGoHomeWithChildrenGroup {
    children: List<{
        groupId: string;
        id: string;
        name: NameRecord;
        profileImage: {
            url: string;
        };
    }>;
    color: string;
    groupId: string;
    profileImage: {
        url: string;
    };
    title: string;
    childId: string;
    id: string;
}

export const GoHomeWithChildrenGroup = Record<IGoHomeWithChildrenGroup>({
    children: List(),
    color: '',
    groupId: '',
    profileImage: {
        url: '',
    },
    title: '',
    childId: '',
    id: '',
});

function fromAPI(data, originalPayload) {
    return new GoHomeWithChildrenGroup({
        ...data,
        id: data.groupId,
        profileImage: {
            url: data.image,
        },
        childId: originalPayload.childId,
        children: List(
            data.children.map(child => {
                return {
                    groupId: data.groupId,
                    id: child.childId,
                    name: Name.nameFromString(child.name),
                    profileImage: {
                        url: child.image,
                    },
                };
            }),
        ),
    });
}

const GoHomeWithChildrenEntityModel: EntityModel<IGoHomeWithChildrenGroup> = {
    record: GoHomeWithChildrenGroup,
    default: new GoHomeWithChildrenGroup(),
    fromAPI,
};

export default GoHomeWithChildrenEntityModel;
